import { AxiosRequestConfig } from "axios";
import { Api } from "./Api";
import { apiConfig } from "../config/apiConfig";
import { saveAs } from "file-saver";
import { PAYMENT_STATUS } from "../constants/common";
import { TaxDocument } from "../model/tax/tax_document";
import { Uploaded1040Document } from "../model/tax/irs1040";
import { UploadedW2DocumentCollection } from "../model/tax/irsw2";
import { SaveTaxReturnResponse, TaxReturnStatusResponse } from "../model/tax/tax_return";
import { UploadedSchedule1DocumentCollection } from "../model/tax/irsschedule1";
import { FormTypes } from "../utils/models";
import { ApiResponse } from "../model/api";
import { UpdateTaxSummaryRequest } from "../model/final_balance/tax_summary";

class TaxApi extends Api {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig);

    this.fetchTaxReturn = this.fetchTaxReturn.bind(this);
    this.fetch1040FormDetails = this.fetch1040FormDetails.bind(this);
    this.fetchW2FormDetails = this.fetchW2FormDetails.bind(this);
    this.fetchSchedule1FormDetails = this.fetchSchedule1FormDetails.bind(this);
    this.confirmDocument = this.confirmDocument.bind(this);
    this.deleteDocument = this.deleteDocument.bind(this);
    this.updateScheduleCForm = this.updateScheduleCForm.bind(this);
    this.fetchScheduleCFormDetails = this.fetchScheduleCFormDetails.bind(this);
  }

  public fetchTaxReturn(): Promise<ApiResponse<TaxReturnStatusResponse>> {
    return this.get("/tax_return_status");
  }

  public fetch1040FormDetails = () => this.get<Uploaded1040Document>("/forms/IRS1040");

  public fetchW2FormDetails = () => this.get<UploadedW2DocumentCollection>("/forms/IRSW2");

  public fetchSchedule1FormDetails = () => 
    this.get<UploadedSchedule1DocumentCollection>("/forms/IRSSchedule1");

  public uploadFile = (payload: {file: File, tax_form_type: FormTypes}) => {
    const formData = new FormData();
    formData.append("file", payload.file);
    formData.append("tax_form_type", payload.tax_form_type);
    return this.post("/forms/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }) as Promise<ApiResponse<TaxDocument<any>>>;
  };

  public confirmDocument<T extends SaveTaxReturnResponse>(
    document: TaxDocument<any>
  ): Promise<ApiResponse<T>> {
    return document.uploaded_file.id ?
      this.put(`${document.resource_uri}/${document.uploaded_file.id}`, {
        ...document.uploaded_file, ...document.form_data} ) :
      this.post(document.resource_uri, {...document.uploaded_file, ...document.form_data} );
  }

  public deleteDocument<T extends SaveTaxReturnResponse>(
    document: TaxDocument<any>
  ): Promise<ApiResponse<T>> {
    return this.delete(`${document.resource_uri}/${document.uploaded_file.id}`);
  }

  public updateScheduleCForm = async ({ id, payload }: any) =>
    this.put(`/forms/IRSScheduleC/${id}`, payload);
      
  public deleteScheduleCForm = (id: string) =>
    this.delete(`/forms/IRSScheduleC/${id}`);
      
  public fetchScheduleCFormDetails = () =>
    this.get("/forms/IRSScheduleC");
  
  public downloadFile = async (data: {
    file_name: string;
    user_id: number;
  }) => {
    try {
      const params = this.encodeQueryParams(data);
      const response = await this.get(`/download?${params}`, {
        responseType: "blob",
      });
      const blob = new Blob([response as any]);
      saveAs(blob, data.file_name);
    } catch (error) {
      console.log("error", error);
    }
  };
}

export const taxApi = new TaxApi(apiConfig);
